module.exports = __webpack_public_path__ + "img/carshinaused_24.aa1803ce.jpg";